import { api, failure } from '@kanos/web-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useSwitchFirm() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (tenantId: string) => {
      const { error, response } = await api.PUT('/api/v1/me/active-firm', { body: { tenantId } });
      if (!response.ok) throw failure('setActiveFirm', error, response.status);
    },
    // Everything cached belongs to the previous firm.
    onSuccess: () => queryClient.resetQueries(),
  });
}
